export const DEFAULT_APPLY_STATES = true;
